import { httpClient } from 'common/services';
import type {
  EnvironmentVariablesConfig,
  PostLoginEnvironmentVariablesConfig,
  PreLoginEnvironmentVariablesConfig,
} from 'features/environment/interfaces';

type HttpRequestError = Error & {
  status?: number;
};

const isNotFoundRequestError = (error: unknown) =>
  (error as HttpRequestError | null)?.status === 404;

/**
 * @deprecated Use getPreLoginEnvironmentConfig or getPostLoginEnvironmentConfig instead.
 * this will be removed in the future, as we want to have separate configs for pre-login and post-login states. If you need to get environment config, please use one of the specific methods based on your needs
 */
async function getEnvironmentConfig() {
  const route = '/client-config';
  const response = await httpClient.get<EnvironmentVariablesConfig>(route);
  return response.data;
}

async function getPreLoginEnvironmentConfig(): Promise<
  PreLoginEnvironmentVariablesConfig | EnvironmentVariablesConfig
> {
  try {
    const route = '/client-config/pre-login';
    const response =
      await httpClient.get<PreLoginEnvironmentVariablesConfig>(route);
    return response.data;
  } catch (error) {
    if (!isNotFoundRequestError(error)) {
      throw error;
    }

    return getEnvironmentConfig();
  }
}

async function getPostLoginEnvironmentConfig(): Promise<
  PostLoginEnvironmentVariablesConfig | EnvironmentVariablesConfig
> {
  try {
    const route = '/client-config/post-login';
    const response =
      await httpClient.get<PostLoginEnvironmentVariablesConfig>(route);
    return response.data;
  } catch (error) {
    if (!isNotFoundRequestError(error)) {
      throw error;
    }

    return getEnvironmentConfig();
  }
}

export const EnvironmentDaoService = {
  getEnvironmentConfig,
  getPreLoginEnvironmentConfig,
  getPostLoginEnvironmentConfig,
};
